import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { LaborTypeRow } from "~produce/purchasing/costs/columnDefs/laborTypesColDef";

interface LaborTypeState {
	selectedLaborType?: LaborTypeRow;
}

const initialState: LaborTypeState = {};

export const laborTypeSlice = createSlice({
	initialState,
	name: "laborType",
	reducers: {
		clearSelectedLaborType: (state) => {
			state.selectedLaborType = undefined;
		},
		setSelectedLaborType: (state, action: PayloadAction<LaborTypeRow | null>) => {
			if (action.payload === null) {
				state.selectedLaborType = undefined;
				return;
			}
			state.selectedLaborType = { ...action.payload };
		},
		updateSelectedLaborType: (state, action: PayloadAction<Partial<LaborTypeRow>>) => {
			if (!state.selectedLaborType) return;
			state.selectedLaborType = { ...state.selectedLaborType, ...action.payload };
		}
	}
});

export const { clearSelectedLaborType, setSelectedLaborType, updateSelectedLaborType } = laborTypeSlice.actions;
export default laborTypeSlice.reducer;
